"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGlobalErrorListener = exports.useActions = void 0;
const react_1 = require("react");
/**
 * Wraps async functions invocation (ie remote method) in try/catch/finally,
 * maintaining `progress` and `error` state.
 *
 *```typescript
 * const {error, action} = useActions()

 * const create = action(async () => {
 *   await service.user.create()
 * })

 * return (
 *   <div>
 *     {error && <div>{error}</div>}
 *     <button onClick={create} disabled={create.progress}>Create</button>
 *   </div>
 * )
 * ```

 * In addition, action functions calls preventDefault for its first parameter, which makes it handy to use in `a` elements:
 * ```
 * <a href="#" onClick={create}>Create</a>
 * ```
 */
function useActions() {
    const [error, setError] = (0, react_1.useState)();
    const [progress, setProgress] = (0, react_1.useState)(undefined);
    let actionIndex = 0;
    function action(impl) {
        actionIndex++;
        const thisActionIndex = actionIndex;
        const trackedAction = (async (e, params) => {
            e && e.preventDefault && e.preventDefault();
            try {
                setProgress(thisActionIndex);
                setError(undefined);
                await impl(params);
            }
            catch (e) {
                globalErrorListener(e);
                setError(e.message);
            }
            finally {
                setProgress(undefined);
            }
        });
        trackedAction.progress = progress == thisActionIndex;
        return trackedAction;
    }
    return {
        error,
        progress: !!progress,
        action: action,
    };
}
exports.useActions = useActions;
let globalErrorListener = () => { };
function setGlobalErrorListener(listener) {
    globalErrorListener = listener;
}
exports.setGlobalErrorListener = setGlobalErrorListener;
